import { useState } from "react";
import { Link } from "react-router-dom";
import HamburgerMenu from "./HamburgerMenu";
import SiteFooter from "./SiteFooter";
import { useCompany } from "../context/CompanyContext";

/**
 * Shared dark-luxury shell for the public marketing site.
 *
 * Iter170: footer extracted to <SiteFooter /> with a richer 4-column layout
 *   covering brand+trust, legal/policies, contact and company info — keeps
 *   the marketing pages consistent and conformity-friendly.
 */
export default function MarketingLayout({ children }) {
  const { company, logoDark } = useCompany();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#041f1b] text-[#fdfbf7] antialiased">
      <header className="sticky top-0 z-30 bg-[#041f1b] border-b border-[#1a4640]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 grid grid-cols-[auto_1fr_auto] items-center gap-3">
          <HamburgerMenu open={menuOpen} onOpenChange={setMenuOpen} />
          <Link to="/" className="justify-self-center inline-flex items-center"
                data-testid="brand-link"
                aria-label={`${company.trade_name} — Início`}>
            <span className="bg-[#fdfbf7] rounded-sm px-2 py-0.5 inline-flex items-center">
              <img src={logoDark}
                   alt={company.trade_name}
                   className="h-12 sm:h-[52px] w-auto select-none pointer-events-none"
                   loading="eager" decoding="async" />
            </span>
          </Link>
          <div className="justify-self-end inline-flex items-center gap-2"
               data-testid="header-auth-actions">
            <Link to="/login"
                  className="inline-flex items-center px-3 sm:px-4 py-2 rounded-sm text-xs uppercase tracking-widest text-[#d4af37] hover:bg-[#d4af37]/10 focus:outline-none focus:ring-2 focus:ring-[#d4af37]/50 transition-colors"
                  data-testid="nav-login">
              Entrar
            </Link>
            <Link to="/registo"
                  className="inline-flex items-center px-3 sm:px-4 py-2 rounded-sm text-xs uppercase tracking-widest font-semibold text-[#031411] bg-[#d4af37] hover:bg-[#f5d76e] shadow-md shadow-[#d4af37]/20 focus:outline-none focus:ring-2 focus:ring-[#d4af37] transition-colors"
                  data-testid="nav-register">
              Criar conta
            </Link>
          </div>
        </div>
      </header>

      <main>{children}</main>
      <SiteFooter />
    </div>
  );
}
